import { Badge } from '@mantine/core';
import { useTranslation } from '../context/TranslationContext';

export default function FreeItemBadge() {
  const { t } = useTranslation();
  return (
    <Badge
      color="green"
      size="xs"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
      }}
    >
      {t('free', 'FREE')}
    </Badge>
  );
}
